import React from "react";

const IconSpotifySvg = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.7915 18.1892C25.3477 14.2162 14.7177 13.8508 8.56615 15.7892C7.57846 16.1 6.53385 15.5215 6.23538 14.4962C5.93538 13.47 6.49231 12.3862 7.48154 12.0746C14.5431 9.84923 26.2815 10.2785 33.7 14.8508C34.5885 15.3977 34.88 16.5892 34.3531 17.51C33.8262 18.4331 32.6777 18.7369 31.7915 18.1892ZM32.0746 23.1608C31.6169 23.8369 30.6454 24.0485 29.9031 23.6338C24.4623 20.5908 16.1662 19.7085 9.73 21.4869C8.89538 21.7162 8.01308 21.2877 7.76 20.53C7.50846 19.77 7.97923 18.9692 8.81231 18.7385C16.1662 16.7077 25.3062 17.6915 31.5554 21.1862C32.2969 21.6015 32.5308 22.4862 32.0746 23.1608ZM29.0492 29.41C28.8786 29.689 28.6041 29.8888 28.2862 29.9655C27.9683 30.0422 27.633 29.9896 27.3538 29.8192C22.7069 26.9862 16.8577 26.3462 9.96923 27.9154C9.65077 27.9886 9.31628 27.9323 9.03932 27.7589C8.76235 27.5855 8.56559 27.3092 8.49231 26.9908C8.45617 26.8331 8.45153 26.6698 8.47867 26.5103C8.50582 26.3508 8.5642 26.1982 8.65047 26.0613C8.73674 25.9244 8.8492 25.806 8.98139 25.7127C9.11358 25.6194 9.2629 25.5531 9.42077 25.5177C16.9592 23.7985 23.4246 24.5385 28.64 27.7177C29.2215 28.0715 29.4046 28.83 29.0492 29.41ZM20 0C8.95385 0 0 8.95385 0 20C0 31.0462 8.95385 40 20 40C31.0462 40 40 31.0462 40 20C40 8.95385 31.0462 0 20 0Z"
      fill="#1DB954"
    />
  </svg>
);

export default IconSpotifySvg;
